import type { Dispatch, SetStateAction } from 'react';
import { FormProvider } from 'react-hook-form';
import ModbenHeroImage from '../modben-hero-image/modben-hero-image';
import { SectionContainer } from './styles';
import type { HeroImageForm } from './types';

interface ModbenHeroImageElementProps {
  form: HeroImageForm;
  isCloneBenefit: boolean;
  setIsUploadInProgress: Dispatch<SetStateAction<boolean>>;
}

const ModbenHeroImageElement = ({
  form,
  isCloneBenefit,
  setIsUploadInProgress,
}: ModbenHeroImageElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <ModbenHeroImage
        isCloneBenefit={isCloneBenefit}
        setIsUploadInProgress={setIsUploadInProgress}
      />
    </FormProvider>
  </SectionContainer>
);

export default ModbenHeroImageElement;
